<template>
    <div class="fixed-rep-example">
        <h5 class="fixed-rep-example__h5">Representative Example</h5>

        <div class="fixed-rep-example__quote">
            <div class="fixed-rep-example__box">
                <div class="fixed-rep-example__subtitle">Monthly Payment</div>
                <div class="fixed-rep-example__value">£318.34</div>
            </div>
            <div class="fixed-rep-example__box">
                <div class="fixed-rep-example__subtitle">Deposit</div>
                <div class="fixed-rep-example__value">£5,315.00</div>
            </div>
            <div class="fixed-rep-example__box">
                <div class="fixed-rep-example__subtitle">Term (months)</div>
                <div class="fixed-rep-example__value">48</div>
            </div>
            <div class="fixed-rep-example__box">
                <div class="fixed-rep-example__subtitle">Cash Price</div>
                <div class="fixed-rep-example__value">£16,971.00</div>
            </div>
            <div class="fixed-rep-example__box">
                <div class="fixed-rep-example__subtitle">Total Advance</div>
                <div class="fixed-rep-example__value">£11,656.00</div>
            </div>
            <div class="fixed-rep-example__box">
                <div class="fixed-rep-example__subtitle">Total Credit Charge</div>
                <div class="fixed-rep-example__value">£3,624.32</div>
            </div>
            <div class="fixed-rep-example__box">
                <div class="fixed-rep-example__subtitle">Total Amount Payable</div>
                <div class="fixed-rep-example__value">£20,595.32</div>
            </div>
            <div class="fixed-rep-example__box">
                <div class="fixed-rep-example__subtitle">APR Representative</div>
                <div class="fixed-rep-example__value">14.9%</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Finance/FixedRepresentativeExample.vue